import { filterPage } from "components/common/Filters/FiltersHelper";
import Basictabs from "components/common/Tabs";
import { clearFilter } from "components/features/AboveProperty/AboveProperty.slice";
import { useDispatch } from "react-redux";
import PropertyPlans from "./PropertyPlans";
import TemplatePlans from "./TemplatePlans";
import { setSearchText as filtersSearchText } from "components/common/Filters/Filters.slice";
import { setSearchText as AbovePropertySearchText } from "components/features/AboveProperty/AboveProperty.slice";

function AbovePropertyList() {
  const dispatch = useDispatch();
  return (
    <>
      <Basictabs
        isParentTab
        tabDetails={[
          {
            label: "Property Plans",
            content: PropertyPlans,
            filtersToClear: [filterPage.inncodePlansDisplay]
          },
          {
            label: "Template Plans",
            content: TemplatePlans
          }
        ]}
        alignItems="left"
        marginBottom="0"
        onTabChangeFn={() => {
          dispatch(filtersSearchText(""));
          dispatch(
            AbovePropertySearchText({
              inputText: "",
              searchType: "templatePlans",
              filterName: "searchText",
              parentView: "myPlans"
            })
          );
          dispatch(clearFilter({ parentView: "myPlans", filterType: "templatePlans" }));
        }}
      />
    </>
  );
}

export default AbovePropertyList;
